import { useEffect, useState, useRef } from 'react';
import axios from 'axios';

// For Emergent deployments, frontend and backend share the same domain
// Always use window.location.origin for maximum compatibility
const API_URL = window.location.origin;

export const AuthCallback = () => {
  const [status, setStatus] = useState('Authenticating...');
  const [error, setError] = useState(null);
  const processedRef = useRef(false);

  useEffect(() => {
    // Prevent double execution
    if (processedRef.current) return;
    processedRef.current = true;

    const processAuth = async () => {
      try {
        // Get session_id from URL hash
        const hash = window.location.hash;
        console.log('AuthCallback: URL hash:', hash);
        console.log('AuthCallback: API URL:', API_URL);
        
        if (!hash || !hash.includes('session_id=')) {
          console.log('AuthCallback: No session_id in hash');
          setStatus('No session found. Redirecting...');
          setTimeout(() => { window.location.href = '/'; }, 1500);
          return;
        }

        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');
        
        if (!sessionId) {
          console.log('AuthCallback: session_id is empty');
          setStatus('Invalid session. Redirecting...');
          setTimeout(() => { window.location.href = '/'; }, 1500);
          return;
        }

        console.log('AuthCallback: Got session_id, exchanging...');
        setStatus('Setting up your account...');

        // Call the session exchange API
        const response = await axios.post(
          `${API_URL}/api/auth/session`,
          { session_id: sessionId },
          { 
            withCredentials: true,
            timeout: 15000, // 15 second timeout
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );

        console.log('AuthCallback: Session exchange response:', response.status);
        
        // Save token to localStorage
        if (response.data && response.data.session_token) {
          localStorage.setItem('session_token', response.data.session_token);
          console.log('AuthCallback: Token saved to localStorage');
        } else {
          console.warn('AuthCallback: No session_token in response:', response.data);
        }

        setStatus('Success! Redirecting to dashboard...');
        
        // Redirect to dashboard
        setTimeout(() => {
          window.location.href = '/dashboard';
        }, 500);

      } catch (err) {
        console.error('AuthCallback: Error:', err);
        console.error('AuthCallback: Error response:', err.response?.data);
        console.error('AuthCallback: Error status:', err.response?.status);
        console.error('AuthCallback: Error message:', err.message);
        console.error('AuthCallback: Is network error:', err.code === 'ERR_NETWORK');
        
        let errorMessage = 'Authentication failed';
        if (err.code === 'ERR_NETWORK') {
          errorMessage = 'Network error - please check your connection and try again';
        } else if (err.response?.data?.detail) {
          errorMessage = err.response.data.detail;
        } else if (err.message) {
          errorMessage = err.message;
        }
        
        setError(errorMessage);
        setStatus('Authentication failed');
        
        setTimeout(() => {
          window.location.href = '/';
        }, 3000);
      }
    };

    processAuth();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[hsl(40,23%,96%)]">
      <div className="text-center max-w-md px-4">
        {!error && (
          <div className="w-16 h-16 border-4 border-[hsl(22,70%,44%)] border-t-transparent rounded-full animate-spin mx-auto mb-6"></div>
        )}
        <h2 className="text-xl font-semibold text-[hsl(120,10%,18%)] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
          {status}
        </h2>
        {error && (
          <div className="mt-4">
            <p className="text-red-600 text-sm mb-4">{error}</p>
            <button 
              onClick={() => window.location.href = '/'}
              className="px-4 py-2 bg-[hsl(22,70%,44%)] text-white rounded-lg hover:opacity-90 transition"
            >
              Return to Home
            </button>
          </div>
        )}
        <p className="text-stone-600 mt-2">Please wait</p>
      </div>
    </div>
  );
};
